import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { SvgIcon } from '@mui/material';
import Lock from '../icons/lock.svg?react';
import { Container, Form, Row, Col } from "react-bootstrap";
import { customValidators, object, string } from '../../../Helpers/Validators/customValidators'
import { SelectInput, TextInput, StyledRadioInput } from "../../../Helpers/Inputs";
import GetStateListForAflac from '../Helpers/StateListForAflac';
import { InputMaskPhone } from "../../../Helpers/Formatters";
import BackNext from '../../Common/SubComponents/BackNext';

export default function ThirdPartyDemoGraphic(props) {
    const formMethods = useForm({
        resolver: yupResolver(ThirdPartyDemoGraphic.ValidationSchema),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { handleSubmit, trigger } = formMethods;

    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
        trigger(field);
    };

    const onSubmit = () => {
        props.onNext();
    };
    const SeclectBoxOption = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const getDisabled = (props.formState.includeSecondaryAddressee === "yes" && (props.formState.firstName === '' || props.formState.middleInitial === '' || props.formState.lastName === ''
        || props.formState.street === '' || props.formState.city === '' || props.formState.state === ''
        || props.formState.zip === '' || props.formState.phoneNumber === ''));

    return (
        <Container fluid className='border-class'>
            <Row className="ThirdParty justify-content-center">
                <Col>
                    <Row className="justify-content-center mt-4">
                        <Col className='col-div'>
                            <div className="text-center mb-2 pt-4"><SvgIcon component={Lock} className="small-icons" color="primary" fontSize="large" /></div>
                            <div className="text-center form-title">Third Party Information</div>
                            <div className="text-center">You have the right to designate a person other than yourself to receive notice of lapse or termination of this insurance policy for nonpayment of premium.</div>
                        </Col>
                    </Row>

                    <FormProvider {...formMethods}>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="justify-content-center pt-4">
                                <Col lg={5} className='w-100'>
                                    <h6 className='pb-2'>Do you wish to name a third party at this time?</h6>
                                    <div className='mb-3'>
                                        <StyledRadioInput
                                            name="includeSecondaryAddressee"
                                            id="includeSecondaryAddressee"
                                            value={props.formState.includeSecondaryAddressee}
                                            options={SeclectBoxOption}
                                            onChange={(e) => handleValueChange('includeSecondaryAddressee', e)}
                                            isWhiteBackground={true}
                                            isBlankIcon={true}
                                        />
                                    </div>
                                    {props.formState.includeSecondaryAddressee === "yes" && (
                                        <React.Fragment>
                                            <div className='mb-3'>
                                                <TextInput
                                                    name="firstName"
                                                    id="firstName"
                                                    label="First Name"
                                                    value={props.formState.firstName}
                                                    onChange={e => handleValueChange('firstName', e.target.value)}
                                                    inputProps={{
                                                        maxLength: 20,
                                                    }}
                                                />
                                            </div>
                                            <div className='mb-3'>
                                                <TextInput
                                                    name="middleInitial"
                                                    id="middleInitial"
                                                    label="Middle Initial"
                                                    value={props.formState.middleInitial}
                                                    onChange={e => handleValueChange('middleInitial', e.target.value)}
                                                    inputProps={{
                                                        maxLength: 2,
                                                    }}
                                                />
                                            </div>
                                            <div className='mb-3'>
                                                <TextInput
                                                    name="lastName"
                                                    id="lastName"
                                                    label="Last Name"
                                                    value={props.formState.lastName}
                                                    onChange={e => handleValueChange('lastName', e.target.value)}
                                                    inputProps={{
                                                        maxLength: 50,
                                                    }}
                                                />
                                            </div>
                                            <div className='mb-3'>
                                                <p className="section-title">Street Address</p>
                                                <TextInput
                                                    name="street"
                                                    id="street"
                                                    label="Street Address"
                                                    value={props.formState.street}
                                                    onChange={e => handleValueChange('street', e.target.value)}
                                                    inputProps={{
                                                        maxLength: 40,
                                                    }}
                                                />
                                            </div>
                                            <div className='mb-3'>
                                                <TextInput
                                                    name="city"
                                                    id="city"
                                                    label="City"
                                                    value={props.formState.city}
                                                    onChange={e => handleValueChange('city', e.target.value)}
                                                    inputProps={{
                                                        maxLength: 40,
                                                    }}
                                                />
                                            </div>
                                            <Row>
                                                <Col>
                                                    <div className='mb-3'>
                                                        <SelectInput
                                                            name="state"
                                                            id="state"
                                                            value={props.formState.state}
                                                            onChange={(e) => handleValueChange('state', e.target.value)}
                                                            label="State"
                                                            selectOptions={GetStateListForAflac()}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className='mb-3'>
                                                        <TextInput
                                                            name="zip"
                                                            id="zip"
                                                            label="Zip"
                                                            value={props.formState.zip}
                                                            onChange={e => handleValueChange('zip', e.target.value)}
                                                            inputProps={{
                                                                maxLength: 5,
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className='mb-3'>
                                                <TextInput
                                                    name="phoneNumber"
                                                    id="phoneNumber"
                                                    label="Primary Phone Number"
                                                    value={props.formState.phoneNumber}
                                                    onChange={e => handleValueChange('phoneNumber', e.target.value)}
                                                    InputProps={{
                                                        inputComponent: InputMaskPhone,
                                                    }}
                                                />
                                            </div>
                                        </React.Fragment>
                                    )}
                                </Col>
                            </Row>
                            <div className='backnext-wrapper'>
                                <BackNext nextDisabled={getDisabled} onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
                            </div>
                        </Form>
                    </FormProvider>
                </Col>
            </Row>
        </Container>
    );
}

ThirdPartyDemoGraphic.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

ThirdPartyDemoGraphic.ValidationSchema = object().shape({
    includeSecondaryAddressee: string().required('This field is required.'),
    firstName: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema.isValidNameWithFiftyChar("First name is required.", true),
        otherwise: (schema) => schema.notRequired()
    }),
    middleInitial: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema.isValidNameWithFiftyChar('Middle Initials is required', true),
        otherwise: (schema) => schema.notRequired()
    }),
    lastName: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema
            .isValidNameWithFiftyChar("Last name is required.", true),
        otherwise: (schema) => schema.notRequired()
    }),
    street: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema.isValidNameLimitedSpecialChar('Street is required.', true, true),
        otherwise: (schema) => schema.notRequired()
    }),
    city: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema.isValidNameLimitedSpecialChar('City is required.', true, false),
        otherwise: (schema) => schema.notRequired()
    }),
    state: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema.required("State is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    zip: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema
            .required("Zip is required.")
            .matches(/^[0-9]{5}$/, 'Zip code must be 5 number characters.'),
        otherwise: (schema) => schema.notRequired()
    }),
    phoneNumber: customValidators.string().when('includeSecondaryAddressee', {
        is: 'yes',
        then: (schema) => schema
            .required('Phone Number is required.')
            .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
        otherwise: (schema) => schema.notRequired()
    }),
})

ThirdPartyDemoGraphic.DefaultFormState = (prefill = false, basicInfo = null) => {
    return {
        includeSecondaryAddressee: '',
        firstName: (basicInfo && basicInfo.firstName) || '',
        middleInitial: (basicInfo && basicInfo.middleInitial) || '',
        lastName: (basicInfo && basicInfo.lastName) || '',
        street: (basicInfo && basicInfo.street) || '',
        city: (basicInfo && basicInfo.city) || '',
        state: (basicInfo && basicInfo.state) || '',
        zip: (basicInfo && basicInfo.zip) || '',
        phoneNumber: (basicInfo && basicInfo.phoneNumber) || '',
    };
};
